export default __webpack_public_path__ + "static/media/icon-chart.a260a87d.svg";